
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.497 12.5a5.833 5.833 0 1111.667 0 5.833 5.833 0 01-11.667 0z","stroke":"#4CAF50"}}),_c('path',{attrs:{"d":"M6.58 7.917v-2.5a3.75 3.75 0 016.869-2.084","stroke":"#4CAF50","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M10.33 13.333v-1.666","stroke":"#4CAF50","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    